/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiInfo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M3.5 11V3.7h2.6c.9 0 1.6.2 2 .6.5.4.7 1 .7 1.8 0 .9-.3 1.5-.7 1.9-.5.4-1.1.6-2 .6H5V11zm2.2-6H5v2.4h.7c.5 0 .9-.1 1.1-.3s.3-.5.3-.9-.1-.7-.3-.9S6.3 5 5.7 5zm4 6V3.7h1.6l2.3 4.8 2.3-4.8h1.6V11H16V6.3l-1.9 4h-1l-1.9-4V11zM19 3.7V11h1.6V3.7zm-3.7 12 3.3 3.3H17v2h5v-5h-2v1.6l-3.3-3.3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPmiInfo as PmiInfo };
